import React from 'react';
import SectionWrapper from '../ui/SectionWrapper';
import { FiMail, FiLinkedin, FiArrowRight, FiGlobe } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const Contact = () => {
  return (
    <SectionWrapper id="contact" className="bg-white">
      <div className="max-w-4xl mx-auto bg-slate-50 rounded-3xl p-8 md:p-12 border border-slate-100 shadow-sm">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Let's Connect</h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Whether you're looking for advisory on security architecture, identity systems, or strategic startup execution, I'm happy to discuss how I can help.
          </p>
        </div>

        <form className="space-y-6 max-w-xl mx-auto" onSubmit={(e) => e.preventDefault()}>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <label htmlFor="name" className="text-sm font-medium text-slate-700">Name</label>
              <input 
                type="text" 
                id="name" 
                autoComplete="name"
                className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all"
                placeholder="Your Name"
              />
            </div>
            <div className="space-y-2">
              <label htmlFor="email" className="text-sm font-medium text-slate-700">Email</label>
              <input 
                type="email" 
                id="email" 
                autoComplete="email"
                className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all"
                placeholder="marjo@villarosa.tech"
              />
            </div>
          </div>
          
          <div className="space-y-2">
            <label htmlFor="message" className="text-sm font-medium text-slate-700">Message</label>
            <textarea 
              id="message" 
              rows="4" 
              className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-teal-500 focus:border-transparent outline-none transition-all resize-none"
              placeholder="How can I help you?"
            ></textarea>
          </div>

          <button 
            type="submit" 
            className="w-full py-4 bg-teal-600 hover:bg-teal-700 text-white font-bold rounded-lg shadow-md hover:shadow-lg transition-all flex items-center justify-center gap-2"
          >
            Send Message <SafeIcon icon={FiArrowRight} />
          </button>
        </form>

        <div className="mt-12 pt-8 border-t border-slate-200 flex flex-col md:flex-row justify-center items-center gap-8 text-slate-600">
          <a href="mailto:marjo@villarosa.tech" className="flex items-center hover:text-teal-600 transition-colors">
            <SafeIcon icon={FiMail} className="mr-2 text-xl" /> marjo@villarosa.tech
          </a>
          <a href="https://linkedin.com/in/MarjoVillarosa" target="_blank" rel="noopener noreferrer" className="flex items-center hover:text-teal-600 transition-colors">
            <SafeIcon icon={FiLinkedin} className="mr-2 text-xl" /> Linkedin/in/MarjoVillarosa
          </a>
          <a href="https://marjo.villarosa.tech" target="_blank" rel="noopener noreferrer" className="flex items-center hover:text-teal-600 transition-colors">
            <SafeIcon icon={FiGlobe} className="mr-2 text-xl" /> marjo.villarosa.tech
          </a>
        </div>
      </div>
    </SectionWrapper>
  );
};

export default Contact;